import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TruncateMarkup from 'react-truncate-markup';
import { getSizes } from './utils';
 
function ReadMore(props) {
  const { lines, children, onToggleLines, onReadMoreClick } = props;
  const { width } = getSizes();
  const [shouldTruncate, setShouldTruncate] = useState(true);

  const readMoreEllipsis = (buttonTitle) => {
    return (
      <span>
        { buttonTitle === 'More' && (
          '...'
        )}
        
        <button 
          style={{ fontSize: '12px', padding: 0, verticalAlign: 'initial', marginLeft: '5px' }}
          className="btn btn-link"
          onClick={() => handleMoreClick()}>
            {buttonTitle}
          </button>
      </span>
    );
  };

  const toggleTruncate = () => {
    setShouldTruncate(!shouldTruncate);
    onToggleLines(shouldTruncate);
  };

  const handleMoreClick = () => {
    if (onToggleLines) {
      return toggleTruncate();
    }
    if (onReadMoreClick) {
      return onReadMoreClick();
    }
  };

  return (
    <div key={width}>
      {shouldTruncate ? (
        <TruncateMarkup lines={lines} ellipsis={readMoreEllipsis('More')}>
          <div>{children}</div>
        </TruncateMarkup>
      ) : (
        <div>
          {children}
         {readMoreEllipsis('Less')}
        </div>
      )}
    </div>
  );
}

ReadMore.propTypes = {
  children: PropTypes.node.isRequired,
  lines: PropTypes.number
};

export default ReadMore;